import { TranslateDefaultParser } from '@ngx-translate/core';
import { environment } from '@env/environment';

export class CustomTranslateParser extends TranslateDefaultParser {

  toAddPrefix: Boolean = false;

  constructor() {
    super();
    this.toAddPrefix = environment.translationPrefix !== null && environment.translationPrefix.length > 0;
  }
  public getValue(target: any, key: string): any {

    const result = super.getValue.apply(this, [target, key]);

    const finalResult = this.toAddPrefix && result !== undefined ? environment.translationPrefix + result : result;

    if (environment.log.requestedTranslations === true) {
      console.log('requested translation: ', key);
      console.log('found traslation: ', finalResult);
    }
    return finalResult;
  }
}
